export default __webpack_public_path__ + "static/media/loading.122fa845.png";